import { render, staticRenderFns } from "./SystemPin.vue?vue&type=template&id=482b110a&"
import script from "./SystemPin.vue?vue&type=script&lang=js&"
export * from "./SystemPin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('482b110a')) {
      api.createRecord('482b110a', component.options)
    } else {
      api.reload('482b110a', component.options)
    }
    module.hot.accept("./SystemPin.vue?vue&type=template&id=482b110a&", function () {
      api.rerender('482b110a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/SystemPin.vue"
export default component.exports